// extracted by mini-css-extract-plugin
module.exports = {"ticketListHeader":"TicketListHeader_ticketListHeader__wQyt8","actions":"TicketListHeader_actions__1_LtY","link":"TicketListHeader_link__18Ghy"};